import React from 'react';
import Header from './Header';
import Footer from './Footer';
import Breadcrumb from './Breadcrumb';
import { Container } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';
import Sidebar from './Sidebar';

const Layout = ({ children, routes, fluid=true }) => {
  const [sidebarOpen, setSidebarOpen] = React.useState(true);

  return (
    <>
      <div className="app-root">
        <Header onToggleSidebar={() => setSidebarOpen(prev => !prev)} />

        <div className="app-body">
          <Sidebar
            isOpen={sidebarOpen}
            onClose={() => setSidebarOpen(false)}
          />

          <div className="app-content">
            <Container className="flex-grow-1 my-4 app-page" fluid={fluid}>
              {/* <Breadcrumb routes={routes} /> */}
              {children}
            </Container>

            <Footer />
          </div>
        </div>
      </div>

      <ToastContainer />
    </>
  );
};

export default Layout;